import type { SavedItem } from '@lb/domain'

import { routePathForContent } from '../content-routes'

/**
 * Where a line on « My anchors » opens — an app path for `<Link to>`, or null
 * when it has nowhere of its own to go.
 *
 * A `COMMUNITY` line is a post, and the only thread route is
 * `/community/$roomId/posts/$postId`: without its `roomId` there is no way to
 * it (a post in a content discussion carries none), so it opens nothing rather
 * than a link that lands on « not found ». Every other line is a content item,
 * routed by the API's own path segment through `routePathForContent` — which
 * answers null for a type with no page (a phrase).
 */
export function anchorTarget(item: Pick<SavedItem, 'id' | 'source' | 'path' | 'roomId'>): string | null {
  if (item.source === 'COMMUNITY') {
    return item.roomId ? `/community/${item.roomId}/posts/${item.id}` : null
  }
  return item.path ? routePathForContent(item.path, item.id) : null
}
